(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-testimonials"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', event => {
          var SwiperTop = new Swiper('.testimonials__members_small_first', {
              allowTouchMove: false,
              loop: true,
              freeMode: false,
              speed: 6000,
              noSwiping: true,
              autoplay: {
                  delay: -0,
                  disableOnInteraction: false,
              },
              slidesPerView: 'auto',
          });

          var SwiperMiddle = new Swiper('.testimonials__members_small_second', {
              allowTouchMove: false,
              loop: true,
              freeMode: false,
              speed: 6000,
              noSwiping: true,
              autoplay: {
                  delay: -0,
                  reverseDirection: true,
                  disableOnInteraction: false,
              },
              slidesPerView: 'auto',
          });

          var SwiperBottom = new Swiper('.testimonials__members_small_third', {
              allowTouchMove: false,
              loop: true,
              freeMode: false,
              speed: 6000,
              noSwiping: true,
              autoplay: {
                  delay: -0,
                  disableOnInteraction: false,
              },
              slidesPerView: 'auto',
          });
      });
if (window.innerWidth <= 767) {
  $('.frst-child > div').css('display','block');
}
  else{
          var swiper1 = new Swiper('.testimonials__members.frst-child', {
          slidesPerView: '2.75',
          /*observer: true,*/
          /*observeParents: true,*/
          allowTouchMove: true,
          /*centeredSlides:true,*/
          loop: true,
          freeMode: true,
          speed: 10000,
          spaceBetween: 20,
          /*mousewheel: true,*/
          //              direction: 'horizontal',
          //effect: 'fade',
          autoplay: {
              /*delay:.01,*/
              disableOnInteraction: false,
          },
          slidesPerView: 'auto',
          pagination: {
              el: '.solva-pagination',
              clickable: true,
          },

          navigation: {
              nextEl: '.js__lab .swiper-button-next',
              prevEl: '.js__lab .swiper-button-prev',
          },
          breakpoints: {
             320: {
                    slidesPerView: '1',
                },
                480: {
                    slidesPerView: '1',
                },
                640: {
                    slidesPerView: '1.5',
                },
                768: {
                    slidesPerView: '1.25',
                },
                1024: {
                    slidesPerView: '1.75',
                },
                1112: {
                    slidesPerView: '2',
                },
                1290: {
                    slidesPerView: '2.75',
                },
          },
      });
  }

  if (window.innerWidth <= 767) {
    $('.cst-child > div').css('display','block');
  }else{
          var swiper2 = new Swiper('.testimonials__members', {
          slidesPerView: '2.75',
          /*observer: true,*/
          /*observeParents: true,*/
          allowTouchMove: true,
          /*centeredSlides:true,*/
          loop: true,
          freeMode: true,
          speed: 10000,
          spaceBetween: 20,
          /*mousewheel: true,*/
          //              direction: 'horizontal',
          //effect: 'fade',
          autoplay: {
              /*delay:.01,*/
              reverseDirection: true,
              disableOnInteraction: false,
          },
          slidesPerView: 'auto',
          pagination: {
              el: '.solva-pagination',
              clickable: true,
          },

          navigation: {
              nextEl: '.js__lab .swiper-button-next',
              prevEl: '.js__lab .swiper-button-prev',
          },
          breakpoints: {
              320: {
                    slidesPerView: '1',
                },
                480: {
                    slidesPerView: '1',
                },
                640: {
                    slidesPerView: '1.5',
                },
                768: {
                    slidesPerView: '1.25',
                },
                1024: {
                    slidesPerView: '1.75',
                },
                1112: {
                    slidesPerView: '2',
                },
                1290: {
                    slidesPerView: '2.75',
                },
          },
      });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky){
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-announcement"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function () {
    var element = $('.sticky');
    var visibilityThreshold = 700; // The scroll position at which the element becomes visible

    // Initially hide the element
    element.css({
        visibility: 'hidden',
        width: '100%',
        padding: '20px 0px',
        zIndex: '50'
    });

    $(window).scroll(function () {
        var scrollPosition = $(window).scrollTop();

        if (scrollPosition >= visibilityThreshold) {
            element.css({
                visibility: 'visible',
            
                zIndex: '50'
            });
        } else {
            element.css({
                visibility: 'hidden',
                width: '100%',
                padding: '20px 0px',
                zIndex: '50'
            });
        }
    });
});

jQuery('.page-link').click(function (e) {
    e.preventDefault();
    var menu_height = jQuery('header').outerHeight();
    var href = $(this).attr('href');
    setTimeout(function () {
        $('html,body').animate({ scrollTop: $(href).offset().top - menu_height });
    }, 700);
});


  } catch(e) { console.error(e); }
})();
})();
